module.exports = __webpack_public_path__ + "static/media/total-sent-icon.d7032b84.svg";